import { useState, useEffect } from 'react';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import { ReactComponent as Settings } from '@Assets/settings.svg';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import DoneIcon from '@mui/icons-material/Done';
import ToggleStyleSwitch from '@CommonRepresentationalDisplay/Switch/ToggleStyleSwitch';
import Menu from '@mui/material/Menu';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DeletePolicyForm from '@IssueConsoleForms/DeletePolicyForm';
import TextField from '@mui/material/TextField';
import UserAvatar from '@ManagementViews/UserAvatar';
import './PolicyRow.scss';

export default function PolicyRow(props) {

    const [cursor, setCursor] = useState('wait');
    const [userList] = useState(props?.userList);
    const [anchorSettingsMenu, setAnchorSettingsMenu] = useState(null);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);
    const [showDeletePolicyForm, setShowDeletePolicyForm] = useState(false);
    const [itemId, setItemId] = useState(0);
    const [anchorSettingsMenuChange, setAnchorSettingsMenuChange] = useState(null);
    const [showSettingsMenuChange, setShowSettingsMenuChange] = useState(false);
    const [notifyList] = useState(['formAgent', 'admin', 'all']);
    const [expectedActionList] = useState([{id: 1, title: 'Ticket is Not Assigned'}, {id: 2, title:'Ticket is Not Resolved'}]);
    const [performActionList] = useState([{id: 1, title: 'Escalate Ticket'}, {id: 2, title: 'Escalate Ticket And Assigned To'}]);
    const [policyList, setPolicyList] = useState([]);
    const [duration, setDuration] = useState({
        days: 0,
        hours: 0,
        minutes: 0
    });
    const [policyInput, setPolicyInput] = useState({
        duration: 0,
        expectedAction: 1,
        startTimer: 'create',
        performAction: 1,
        newAssignee: 0,
        settings: {
            notification : {
                notifyTo: 'formAgent'
            }
        }
    });
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarType, setSnackBarType] = useState('success');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const MILLIS_IN_MINUTES = 1000 * 60;
    const MILLIS_IN_HOURS = MILLIS_IN_MINUTES * 60;
    const MILLIS_IN_DAYS = MILLIS_IN_HOURS * 24;
    const className = 'policyRow';

    useEffect(()=>{
        renderData();
    },[])

    const renderData = async()=> {
        let policyListTemp = props?.policyList;
        policyListTemp = policyListTemp.map((item)=> ({...item, settings: JSON.parse(item.settings)}));
        setPolicyList(policyListTemp);
        setCursor('auto');
    }

    const handleAddPolicy = ()=> {
        let millis = convertDurationIntoMilliseconds();
        let checkDuration = checkPreviousDuration(millis)
        if(checkDuration) {
            setSnackBarMessage('Duration should be grater then previous one');
            setSnackBarType('error');
            setSnackBarOpen(true);
            return;
        };
        if (millis == 0) {
            setSnackBarMessage('Please set duration');
            setSnackBarType('error');
            setSnackBarOpen(true);
            return;
        };
        let policyInputObj = policyInput;
        policyInputObj.duration = millis;
        policyInputObj.id = Date.now();
        setPolicyList([...policyList, policyInputObj]);
        policyInputObj.settings = JSON.stringify(policyInputObj.settings);
        props?.handleAddPolicy(props?.levelId, policyInputObj);
        setPolicyInput({
            duration: 0,
            expectedAction: 1,
            startTimer: 'create',
            performAction: 1,
            newAssignee: 0,
            settings: {
                notification : {
                    notifyTo: 'formAgent'
                }
            }
        });
        setDuration({days: 0, hours: 0, minutes: 0});
    }

    const convertDurationIntoMilliseconds=()=> {
        let millis = 0;
        millis += duration.days * MILLIS_IN_DAYS;
        millis += duration.hours * MILLIS_IN_HOURS;
        millis += duration.minutes * MILLIS_IN_MINUTES;
        return millis;
    }

    const convertMillisIntoDuration=(millis)=> {
        const days = Math.floor(millis / MILLIS_IN_DAYS);
        millis %= MILLIS_IN_DAYS;
        const hours = Math.floor(millis / MILLIS_IN_HOURS);
        millis %= MILLIS_IN_HOURS;
        const minutes = Math.floor(millis / MILLIS_IN_MINUTES);
        return (days !== 0 ? days + ' Days ' : '') + (hours !== 0 ? hours + ' Hours ' : '') + (minutes !== 0 ? minutes + ' Minutes' : '');
    }

    const checkPreviousDuration = (millis)=> {
        let fifteenMinutesInMillis = 15 * MILLIS_IN_MINUTES;
        let levels = props?.priorityLevels;
        for(let i = 0; i < levels.length; i++) {
            let lvlObj = levels[i];
            let findPolicies = lvlObj.policyList.find((item)=> (item.duration + fifteenMinutesInMillis) >= millis);
            if(!!findPolicies) {
                return true;
            }
        }
        return false;
    }

    const handleChange = (e, type)=> {
        let value = e.target.value;
        setPolicyInput((prev)=> ({
            ...prev,
            [type]: value
        }));
    }

    const handleDurationChange = (e, durationType)=> {
        const value = e.target.value;
        setDuration((duration)=> ({
            ...duration,
            [durationType]: value
        }))
    }

    const toggleDeletePolicyForm = (itemId) => {
        setShowDeletePolicyForm(!showDeletePolicyForm);
        setItemId(itemId);
    };

    const handleSettingsMenuPopup = (event) => {
        if(!showSettingsMenu){
            if(!!event) {
                setAnchorSettingsMenu(event.currentTarget);
                setShowSettingsMenu(true);
            }
        } else {
            setAnchorSettingsMenu(null);
            setShowSettingsMenu(false);
        }
    }

    const handleSettingsMenuPopupChange = (event) => {
        if(!showSettingsMenuChange){
            if(!!event) {
                setAnchorSettingsMenuChange(event.currentTarget);
                setShowSettingsMenuChange(true);
            }
        } else {
            setAnchorSettingsMenuChange(null);
            setShowSettingsMenuChange(false);
        }
    }

    const handleNotificationSettingsChange = (e, type)=> {
        let value = e.target.value;
        let policyInputObj = policyInput;
        let notification = policyInputObj.settings.notification;
        notification[type] = value;
        policyInputObj.settings.notification = notification;
        setPolicyInput({...policyInputObj});
    }

    const handleNotificationToggle = (e)=> {
        let checked = e.target.checked;
        let policyInputObj = policyInput;
        let notification = policyInputObj.settings.notification;
        notification.whatsapp = checked;
        policyInputObj.settings.notification = notification;
        setPolicyInput({...policyInputObj});
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarOpen(false);
    };

    return (
        <div className={className + ' width-wfa'} style={{cursor: cursor}}>
            <div className={className + '__inner'}>
                {
                    policyList?.map((item)=>
                        <div className={className + '__inner__row flex-row-center-1rem-gap'} key={item.id}>
                            <div className={className + '__inner__row__t1'}>
                                {convertMillisIntoDuration(item?.duration)}
                            </div>
                            <div className={className + '__inner__row__t2'}>
                                {item?.expectedAction === 1 ? 'Ticket is Not Assigned' : 'Ticket is Not Resolved'}
                            </div>
                            <div className={className + '__inner__row__t3 flex-row-center-1vw-gap'}>
                               {item?.performAction === 1 ? 'Escalate Ticket' : 'Escalate Ticket And Auto Assignee'}
                            </div>
                            <div className={className + '__inner__row__t4'}>
                                {
                                    item?.newAssignee !== 0 &&
                                        <UserAvatar
                                            profileId={item?.newAssignee}
                                            popover={true}
                                            unassigned={true}
                                            showName={true}
                                            size='medium'/>
                                }
                            </div>
                            <div className={className + '__inner__row__right flex-row-center'}>
                                <div className={className + '__inner__row__right__icons flex-row-center-1rem-gap'} >
                                    <Settings className={className + '__inner__row__right__icons__settings dashboard-icon'} onClick={handleSettingsMenuPopup} />
                                    <DeleteIcon className={className + '__inner__row__right__icons__delete dashboard-icon'} onClick={()=> toggleDeletePolicyForm(item.id)}/>
                                </div>
                                {
                                    showSettingsMenu ?
                                        <Menu
                                            open={showSettingsMenu}
                                            onClose={handleSettingsMenuPopup}
                                            anchorEl={anchorSettingsMenu}>
                                                <div className={className + '__inner__row__right__settingsMenu'}>
                                                    <div className={className + '__inner__row__right__settingsMenu__notification flex-column-flex-start gap-0p5rem width-wfa'}>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__top flex-row-center-space-between width-wfa'}>
                                                            <div className={className + '__inner__row__right__settingsMenu__notification__top__t1'}>
                                                                Notification
                                                            </div>
                                                            <div className={className + '__inner__row__right__settingsMenu__notification__top__toggle'}>
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        row>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <ToggleStyleSwitch
                                                                                    checked={item?.settings?.notification?.whatsapp ?? true}
                                                                                    disabled={true}/>
                                                                            }/>
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </div>
                                                        </div>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__body flex-row-center-space-between width-wfa'}>
                                                            <div className={className + '__inner__row__right__settingsMenu__notification__body__t1'}>
                                                                Notify To
                                                            </div>
                                                            <div className={className + '__inner__row__right__settingsMenu__notification__body__right capitalize'}>
                                                                {item?.settings?.notification?.notifyTo ?? 'Form Agent'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </Menu>
                                    :
                                        null
                                }
                            </div>
                        </div>
                    )
                }
                <div className={className + '__inner__policyForm flex-row-flex-start-1rem-gap'}>
                    <div className={className + '__inner__policyForm__duration flex-column-flex-start-1vh-gap'}>
                        <div className={className + '__inner__policyForm__duration__input flex-row-flex-start-1vw-gap'}>
                            <TextField
                                className={className + '__inner__policyForm__duration__input__textField'}
                                type='number'
                                size='small'
                                variant='outlined'
                                value={duration?.days}
                                onChange={(e) => handleDurationChange(e, 'days')}
                                InputProps={{ inputProps: { min: 0} }}
                                required/>
                            <TextField
                                className={className + '__inner__policyForm__duration__input__textField'}
                                type='number'
                                size='small'
                                value={duration?.hours}
                                onChange={(e) => handleDurationChange(e, 'hours')}
                                InputProps={{ inputProps: { min: 0, max: 24 } }}
                                variant='outlined'
                                required/>
                            <TextField
                                className={className + '__inner__policyForm__duration__input__textField'}
                                type='number'
                                size='small'
                                value={duration?.minutes}
                                onChange={(e) => handleDurationChange(e, 'minutes')}
                                InputProps={{ inputProps: { min: 0, max: 60 } }}
                                variant='outlined'
                                required/>
                        </div>
                        <div className={className + '__inner__policyForm__duration__input grey-text flex-row-center-1vw-gap'}>
                            <div className={className + '__inner__policyForm__duration__input__headers '}>
                                Days
                            </div>
                            <div className={className + '__inner__policyForm__duration__input__headers '}>
                                Hours
                            </div>
                            <div className={className + '__inner__policyForm__duration__input__headers '}>
                                Minutes
                            </div>
                        </div>
                    </div>
                    <div className={className + '__inner__policyForm__expectedAction flex-row-center-1vw-gap'}>
                        <Select
                            sx={{ width: 100 }}
                            value={policyInput?.expectedAction}
                            onChange={(e)=> handleChange(e, 'expectedAction')}
                            className={className + '__inner__policyForm__expectedAction__select capitalize'}>
                            {
                                expectedActionList.map((action, index) => (
                                    <MenuItem key={index} value={action.id} className={'capitalize'}>
                                        {action.title}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                    <div className={className + '__inner__policyForm__performAction flex-row-center-1vw-gap'}>
                        <Select
                            sx={{ width: 100 }}
                            value={policyInput.performAction ?? 0}
                            onChange={(e)=> handleChange(e, 'performAction')}
                            className={className + '__inner__policyForm__performAction__select'}>
                            {
                                performActionList.map((action, index) => (
                                    <MenuItem key={index} value={action.id}>
                                        {action.title}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                    <div className={className + '__inner__policyForm__newAssignee'}>
                        <Select
                            sx={{ width: 100 }}
                            value={policyInput.newAssignee ?? 0}
                            disabled={policyInput.performAction !== 2}
                            onChange={(e)=> handleChange(e, 'newAssignee')}
                            className={className + '__inner__policyForm__newAssignee__select'}>
                            {
                                userList.map((user, index) => (
                                    <MenuItem key={index} value={user.id}>
                                        {user.fullName}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                    <div className={className + '__inner__policyForm__right flex-row-center-1rem-gap'}>
                        <div className={className + '__inner__policyForm__settings'}>
                            <Settings className={className + '__inner__policyForm__settings__icon dashboard-icon'} onClick={handleSettingsMenuPopupChange}/>
                            {
                                showSettingsMenuChange ?
                                    <Menu
                                        open={showSettingsMenuChange}
                                        onClose={handleSettingsMenuPopupChange}
                                        anchorEl={anchorSettingsMenuChange}>
                                            <div className={className + '__inner__row__right__settingsMenu'}>
                                                <div className={className + '__inner__row__right__settingsMenu__notification flex-column-flex-start gap-1rem width-wfa'}>
                                                    <div className={className + '__inner__row__right__settingsMenu__notification__top flex-row-center-space-between width-wfa'}>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__top__t1'}>
                                                            Notification
                                                        </div>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__top__toggle'}>
                                                            <FormControl>
                                                                <RadioGroup
                                                                    row>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <ToggleStyleSwitch
                                                                                checked={policyInput?.settings?.notification?.whatsapp ?? true}
                                                                                onChange={handleNotificationToggle}
                                                                                disabled={cursor === 'wait'}/>
                                                                        }/>
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                    <div className={className + '__inner__row__right__settingsMenu__notification__body flex-row-center-space-between width-wfa'}>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__body__t1'}>
                                                            Notify
                                                        </div>
                                                        <div className={className + '__inner__row__right__settingsMenu__notification__body__right'}>
                                                            <Select
                                                                sx={{ width: 100 }}
                                                                value={policyInput?.settings?.notification?.notifyTo ?? 'formAgent'}
                                                                onChange={(e)=> handleNotificationSettingsChange(e, 'notifyTo')}
                                                                className={className + '__inner__policyForm__newAssignee__notification__body__select capitalize'}>
                                                                {
                                                                    notifyList.map((notify, index) => (
                                                                        <MenuItem key={index} value={notify} className='capitalize'>
                                                                            {notify}
                                                                        </MenuItem>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </Menu>
                                :
                                    null
                            }
                        </div>
                        <button
                            className={className + '__inner__policyForm__right__add dashboard-icon'}
                            onClick={handleAddPolicy}
                            title='Add policy'>
                            <DoneIcon className={className + '__inner__policyForm__right__add__icon'}/>
                        </button>
                    </div>
                </div>
            </div>
            {
                showDeletePolicyForm &&
                <DeletePolicyForm
                    itemId={itemId}
                    open={showDeletePolicyForm}
                    handleRemovePolicy={props.handleRemovePolicy}
                    levelId={props?.levelId}
                    setPolicyList={setPolicyList}
                    closePopup={toggleDeletePolicyForm}
                    renderData={renderData}/>
            }
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackBarClose}>
                <Alert
                    onClose={handleSnackBarClose}
                    severity={snackBarType}
                    variant='filled'
                    sx={{ width: '100%' }}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}